import {getSelectedAudioItem} from '@Components/poster-editor/poster-editor-reducer';
import type {AudioItem} from '@PosterWhiteboard/classes/audio-clips/audio-item.class';
import {useAppSelector} from '@/hooks';

export function useSelectedAudioItem(): AudioItem | null {
  const selectedAudioItem = useAppSelector(getSelectedAudioItem);
  const activeItem = selectedAudioItem ? window.posterEditor?.whiteboard?.getCurrentPage()?.audioClips?.getAudioItemForId(selectedAudioItem.uid) : null;
  if (!activeItem) {
    return null;
  }
  return activeItem;
}
